<div class="apply-one-style" [attr.data-e2e]="e2e">
  <!-- seo zone -->
  <div class="site-width">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="mt-1 mt-md-2 mt-xl-3 col-12 mr-auto" [ngClass]="{ 'col-lg-6': mainPicture }">
          <div class="card-item" [attr.data-e2e]="e2e + '-explanations'">
            <h1 class="mb-1" [attr.data-e2e]="e2e + '-title'">{{ title }}</h1>

            @if (description) {
              @for (item of description; track item; let last = $last) {
                <p
                  class="standard text-mw"
                  [ngClass]="{'mb-0': !last}"
                  [innerHTML]="item"
                ></p>
              }
            }

            @if (!entryPoints || entryPoints.length === 0) {
              <div
                class="text-center text-md-left"
                >
                <a href="" class="btn btn-primary mb-2" (click)="emitLoginEvent();false" [attr.data-e2e]="e2e + '-login'"
                  [attr.aria-label]="accessibleConfirmationLabel ||  (i18nPath + '.authentication.label' | translate)">
                  {{ confirmationLabel || (i18nPath + '.authentication.label' | translate) }}
                </a>
                <!-- find identifier link -->
                @if (isIdentifierLinkDisplayed) {
                  <a
                    [href]="i18nPath + '.identifier.references.0.linkWeb.browser' | translate"
                    class="o-link-arrow mb-1"
                    target="_blank"
                    (click)="emitFindIdentifierEvent()"
                    [attr.data-e2e]="e2e + '-find-identifier'"
                    >
                    {{ i18nPath + '.identifier.label' | translate }}
                  </a>
                }
              </div>
            } @else {
              <ecm-mat-visitor-home-multiple-entry
                [entryPoints]="entryPoints"
                [multiplePossibilitiesLabel]="multiplePossibilitiesLabel"
                (loginEventEmitter)="emitLoginEvent($event)"
                >
              </ecm-mat-visitor-home-multiple-entry>
            }
          </div>
        </div>

        @if (mainPicture) {
          <div class="mt-1 mt-md-2 mt-xl-3 col-5 d-none d-lg-flex">
            <img [src]="mainPicture" alt="" class="ob1-visual w-100" />
          </div>
        }
      </div>

      <!-- accordions -->
      @if (accordions && accordions.length > 0) {
        <ecm-mat-visitor-home-accordions
          [accordions]="accordions"
          [accordionTitle]="accordionTitle"
          [e2e]="e2e + '-accordion'"
          (visitorButtonClick)="emitButtonClickEvent($event.zone, $event.index, $event.href)"
          >
        </ecm-mat-visitor-home-accordions>
      }
    </div>
  </div>

  <!-- reason zone -->
  <div class="bg-dark text-white site-width" [attr.data-e2e]="e2e + '-reason'">
    <div class="container-fluid py-2 py-md-3">
      <h2 class="no-signature mb-1">{{ reason.title }}</h2>

      @if (reason.subTitle) {
        <p class="lead mb-0 mt-2">
          <strong>{{ reason.subTitle }}</strong>
        </p>
      }

      @if (reason.isNumeralList) {
        <ol class="mb-0">
          @for (reason of reason.reasonsList; track reason; let last = $last) {
            <li class="text-white text-mw">{{ reason }}</li>
          }
        </ol>
      } @else {
        <ul class="list mb-0">
          @for (reason of reason.reasonsList; track reason; let last = $last) {
            <li class="text-white text-mw">{{ reason }}</li>
          }
        </ul>
      }

      @if (reason.information) {
        <p class="standard text-mw mb-0">{{ reason.information }}</p>
      }
    </div>
  </div>

  <!-- widgets zone -->
  @for (widget of widgetsArray; track widget) {
    <ecm-mat-visitor-home-widgets
      [widgets]="widget"
      [e2e]="e2e + '-widget'"
      (visitorButtonClick)="emitButtonClickEvent($event.zone, $event.index, $event.href)"
      >
    </ecm-mat-visitor-home-widgets>
  }
</div>
